import { 
  Container, 
  Stack, 
  Typography, 
  Button, 
  Card, 
  useMediaQuery,
  Switch, 
  TableContainer,
  Grid, 
  Table, 
  TableBody, 
  TableRow, 
  TableCell, 
  IconButton, 
  TablePagination,
  Paper,
  Avatar,
  Divider,
  Fade,
  Zoom,
  Tooltip,
  Chip,
  Box
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../../../layouts/user';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MiscSkeleton from '../../../../layouts/user/MiscSkeleton';
import { GetAll, apiURL,Put } from '../../../../utils/apiCalls';
import { filter } from 'lodash';
import EditIcon from '@mui/icons-material/Edit';
import { capitalCase } from 'change-case';
import SearchNotFound from '../../../../layouts/SearchNotFound';
import { styled } from '@mui/material/styles';
import Iconify from '../../../../layouts/Iconify';
import { 
  Map as MapIcon,
  LocationOn,
  Edit,
  Add,
  FilterList,
  Visibility,
  Business,
  MyLocation
} from '@mui/icons-material';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'no', label: 'SNo.', align: 'center' },
    { id: 'name', label: 'Project Name', align: 'center' },
    { id: 'description', label: 'Description', align: 'center' },
    { id: 'lag', label: 'Longitude', align: 'center' },
    { id: 'lat', label: 'Latitude', align: 'center' },
    { id: 'is_active', label: 'Active', align: 'center' },
    { id: 'edit', label: 'Edit', align: 'center' },
  ];
  
  // ----------------------------------------------------------------------
  
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (_user) => JSON.stringify(_user['name']).toLowerCase().trim().indexOf(query.toLowerCase().trim()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
  }

const MapList = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');
    
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState();
    const [filterName, setFilterName] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
  
    async function GetList () {
      setLoading(true);
      const response = await GetAll(apiURL + '/api/v1/map_project_locations?is_active=false');
           if(response) {
          if (response.data.status) {       
          setLoading(false);
          setList(response.data.data)
          }
          else {
          setLoading(false);
          toast.error(response.data.message)
            setList([])
          }
        }
        else {
          setLoading(false);
        }
  };
  
    useEffect(()=> {
      GetList();    
    },[])
  
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = list.map((n) => n.exporter_company_Name);
        setSelected(newSelecteds);
        return;
      }
      setSelected([]);
    };
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const handleFilterByName = (event) => {
      setFilterName(event.target.value);
    };
  
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - list.length) : 0;
  
    const filteredUsers = applySortFilter(list, getComparator(order, orderBy), filterName);
  
    const isUserNotFound = filteredUsers.length === 0;
    
    const handleClickEdit = (e, id) => {
     navigate(`/dashboard/MapEditCreate/${id}`)
  };

  const togglechange = async (e, id) => {
    const response = await Put(apiURL + "/api/v1/map_project_locations/", id, {
    is_active: e.target.checked,
    });
    if (response && response.data && response.data.status) {
      GetList();
    }
  };
    return (
        <Container sx={{m:0, width:'100%', maxWidth:'100%'}} maxWidth={false}>
        <Fade in timeout={800}>
          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
              <Avatar sx={{ 
                bgcolor: '#1976d2', 
                width: 48, 
                height: 48,
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
              }}>
                <MapIcon sx={{ fontSize: 24, color: 'white' }} />
              </Avatar>
              <Box>
            <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
              Map Locations Management
            </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Manage and configure project map locations
          </Typography>
              </Box>
        </Stack>
            <Divider sx={{ my: 2 }} />
          </Box>
        </Fade>

        <Zoom in timeout={600}>
          <Card sx={{ 
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            borderRadius: 3,
            overflow: 'hidden'
          }}>
            {/* Enhanced Toolbar Section */}
            <Paper
              elevation={0}
              sx={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                p: 2,
                borderBottom: '1px solid #e0e0e0'
              }}
            >
              <Grid container spacing={1} alignItems="center">
              <Grid item xs={12} sm={6} lg={6} md={6} xl={6}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Avatar
                      sx={{
                        width: 32,
                        height: 32,
                        background: '#1976d2'
                      }}
                    >
                      <FilterList sx={{ fontSize: 16, color: 'white' }} />
                    </Avatar>
                    <Box>
                      <Typography variant="subtitle1" sx={{ color: '#333', fontWeight: 600 }}>
                        Search & Filter
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666', fontSize: '0.75rem' }}>
                        Find map locations by project name
                      </Typography>
                    </Box>
                  </Stack>
              </Grid>
              <Grid item xs={12} sm={6} lg={6} md={6} xl={6} sx={{ justifyContent: isMobile ? 'center' : 'flex-end', alignItems: 'center', display: 'flex' }}>
                  <Button 
                    variant='contained' 
                    onClick={() => navigate('/dashboard/MapEditCreate')} 
                    sx={{ 
                      height: 'max-content', 
                      marginRight: '24px !important', 
                      marginBottom: '15px !important', 
                      width: isMobile ? '80%' : 'max-content',
                      background: '#1976d2',
                      '&:hover': {
                        background: '#1565c0'
                      },
                      borderRadius: 2,
                      px: 2,
                      py: 1,
                      fontSize: '0.875rem'
                    }}
                    startIcon={<Add sx={{ fontSize: 16 }} />}
                  >
                    Create Location
                  </Button>
              </Grid>
              </Grid>
              <Box sx={{ mt: 2 }}>
                <UserListToolbar 
                  placeholder="Search by Project Name" 
                  numSelected={selected.length} 
                  filterName={filterName} 
                  onFilterName={handleFilterByName} 
                />
              </Box>
            </Paper>

          {/* <Scrollbar sx={undefined}> */}
            <TableContainer sx={{ overflowX: 'auto'}}>
              <Table stickyHeader >
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={list.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  isCheckbox={false}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    const { id, name, description,lag,lat,is_active } = row;
                    return (
                      <TableRow 
                        hover 
                        key={id}
                        sx={{
                          '&:hover': {
                            backgroundColor: 'rgba(25, 118, 210, 0.04)',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 12px rgba(25, 118, 210, 0.15)'
                          },
                          transition: 'all 0.2s ease-in-out'
                        }}
                      >
                        <TableCell component="th" scope="row" align="center" sx={{p:'12px'}}>
                          <Chip
                            label={index + 1}
                            size="small"
                            sx={{
                              background: '#1976d2',
                              color: 'white',
                              fontWeight: 600,
                              minWidth: '32px'
                            }}
                          />
                        </TableCell>
                        <TableCell align="center" sx={{p:'12px'}}>
                          <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                            <Business sx={{ fontSize: 16, color: '#1976d2' }} />
                            <Typography sx={{ color: '#1976d2', fontWeight: 600 }}>
                              {capitalCase(name)}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="center" sx={{p:'12px'}}>
                          <Typography variant="body2" sx={{ color: '#666' }}>
                            {description}
                          </Typography>
                        </TableCell>
                        <TableCell align="center" sx={{p:'12px'}}>
                          <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                            <LocationOn sx={{ fontSize: 16, color: '#1976d2' }} />
                            <Typography sx={{ color: '#1976d2', fontWeight: 500 }}>
                              {lag}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="center" sx={{p:'12px'}}>
                          <Stack direction="row" alignItems="center" spacing={1} justifyContent="center">
                            <MyLocation sx={{ fontSize: 16, color: '#1976d2' }} />
                            <Typography sx={{ color: '#1976d2', fontWeight: 500 }}>
                              {lat}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="center" sx={{p:'12px'}}>
                          <Chip
                            label={is_active ? 'Active' : 'Inactive'}
                            size="small"
                            sx={{
                              background: is_active ? '#4caf50' : '#f44336',
                              color: 'white',
                              fontWeight: 500
                            }}
                          />
                          <Switch
                            checked={is_active}
                            onChange={(e) => {
                              togglechange(e,id);
                            }}
                            sx={{ ml: 1 }}
                          />
                        </TableCell>
                        <TableCell align="center" sx={{p:'12px'}}>
                          <Tooltip title="Edit Location">
                            <IconButton 
                              onClick={(e) => handleClickEdit(e, id)}
                              sx={{
                                background: '#1976d2',
                                color: 'white',
                                '&:hover': {
                                  background: '#1565c0',
                                  transform: 'scale(1.1)'
                                },
                                transition: 'all 0.2s ease-in-out'
                              }}
                            >
                              <Edit sx={{ fontSize: 18 }} />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isUserNotFound && (
                  <TableBody> {loading ? <MiscSkeleton record={{number: 7}}/> :
                    <TableRow>
                      <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                       {list.length <=0 ? <Typography gutterBottom align="center" variant="subtitle1"> Not found</Typography> :<SearchNotFound searchQuery={filterName} /> }
                      </TableCell>
                    </TableRow> }
                  </TableBody> 
                )}
              </Table>
            </TableContainer>
          {/* </Scrollbar> */}

          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                borderTop: '1px solid #e0e0e0'
              }}
          />
        </Card>
        </Zoom>

        {/* Professional Stats Footer */}
        <Fade in timeout={1000}>
          <Paper
            elevation={0}
            sx={{
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              borderRadius: 3,
              p: 3,
              mt: 3,
              border: '1px solid #e0e0e0'
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar
                    sx={{
                      width: 48,
                      height: 48,
                      background: '#1976d2'
                    }}
                  >
                    <MapIcon sx={{ fontSize: 24, color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                      Total Locations
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666' }}>
                      {list.length} map locations configured
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar
                    sx={{
                      width: 40,
                      height: 40,
                      background: '#4caf50'
                    }}
                  >
                    <LocationOn sx={{ fontSize: 20, color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                      Active Locations
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666' }}>
                      {list.filter(item => item.is_active).length} currently active
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Avatar
                    sx={{
                      width: 40,
                      height: 40,
                      background: '#ff9800'
                    }}
                  >
                    <Business sx={{ fontSize: 20, color: 'white' }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ color: '#333', fontWeight: 700 }}>
                      Project Coverage
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666' }}>
                      {new Set(list.map(item => item.name)).size} unique projects
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Paper>
        </Fade>
      </Container>
    )
}

export default MapList;

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));